import React, { useEffect, useRef } from "react";

export default function ClientMap({ baseLocation, clients, mapRef }) {
  const mapInstance = useRef(null);

  useEffect(() => {
    if (!window.google || !window.google.maps) return;

    const map = new window.google.maps.Map(mapRef.current, {
      center: baseLocation || { lat: 33.0, lng: 131.0 },
      zoom: 10,
    });
    mapInstance.current = map;

    const bounds = new window.google.maps.LatLngBounds();

    // 出発地点マーカー
    if (baseLocation?.lat && baseLocation?.lng) {
      const origin = new window.google.maps.Marker({
        position: baseLocation,
        map,
        label: "出発",
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 8,
          fillColor: "#4285F4",
          fillOpacity: 1,
          strokeColor: "white",
          strokeWeight: 2,
        },
      });
      bounds.extend(baseLocation);
    }

    // 顧客マーカー
    const routePoints = [];
    clients?.forEach((client, index) => {
      if (client.lat && client.lng) {
        const position = { lat: client.lat, lng: client.lng };
        routePoints.push(position);
        new window.google.maps.Marker({
          position,
          map,
          label: String.fromCharCode(65 + index),
          title: client.name,
        });
        bounds.extend(position);
      }
    });

// ルート線の描画（baseLocation → A → B → C → ...）
if (
  baseLocation?.lat != null &&
  baseLocation?.lng != null &&
  routePoints.length > 0
) {
  const pathPoints = [baseLocation, ...routePoints];
  const polyline = new window.google.maps.Polyline({
    path: pathPoints,
    geodesic: true,
    strokeColor: "#4285F4",
    strokeOpacity: 0.7,
    strokeWeight: 4,
  });
  polyline.setMap(map);
}

    // 表示範囲を自動調整
    map.fitBounds(bounds);

  }, [clients, baseLocation]);

  return (
    <div
      ref={mapRef}
      style={{ width: "100%", height: "400px", borderRadius: 8, marginBottom: 16 }}
    />
  );
}
